import loginedApi from "../apis";
import {
  FETCH_DEPARTMENTS_LIST,
  FETCH_DEPARTMENT_BY_ID,
  ADD_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT,
  SET_DEPARTMENT_LOADING,
  SET_DEPARTMENT_ERROR,
  CLEAR_DEPARTMENT_ERROR,
  FETCH_SPECIALITIES_LIST
} from "./type";
import CryptoJS from "crypto-js";

var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);

const { detect } = require('detect-browser');
const browser = detect();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}

// Fetch Specialities List for Dropdown
export const fetchSpecialities = (status = "All") => async (dispatch) => {
  try {
    const params = {
      requestType: 96, // GET_ALL_SPECIALITIES_REQUEST
      token: hashcode.toString(),
      data: {
        status: status // Optional: "Active", "Inactive", or "All"
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managespeciality", params);

    if (response.status === 200) {
      dispatch({ 
        type: FETCH_SPECIALITIES_LIST, 
        payload: response.data.data 
      });
    }
    
    return response.data.data;
  } catch (error) {
    console.error("Error fetching specialities:", error);
    throw error;
  }
};

// Get All Departments with Pagination
export const fetchDepartmentsList = (page = 1, pageSize = 10, search = "") => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    const params = {
      requestType: 88,
      token: hashcode.toString(),
      data: {
        page: page,
        pageSize: pageSize,
        search: search
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managedepartment", params);

    if (response.status === 200) {
      dispatch({ 
        type: FETCH_DEPARTMENTS_LIST, 
        payload: response.data.data 
      });
    }
    
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    return response.data.data;
  } catch (error) {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to fetch departments" 
    });
    throw error;
  }
};

// Get Department by ID
export const fetchDepartmentById = (ssmId) => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    const params = {
      requestType: 92,
      token: hashcode.toString(),
      data: {
        ssm_id: ssmId
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managedepartment", params);

    if (response.status === 200) {
      dispatch({ 
        type: FETCH_DEPARTMENT_BY_ID, 
        payload: response.data.data 
      });
    }
    
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    return response.data.data;
  } catch (error) {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to fetch department" 
    });
    throw error;
  }
};

// Add New Department
export const addDepartment = (departmentData) => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    // Transform field names to match API expectations
    const apiData = {
      name: departmentData.ssm_secondary_speciality_name,
      primarySpecialityId: departmentData.ssm_primary_speciality_id,
      details: departmentData.ssm_details,
      icon: departmentData.ssm_icon,
      heading: departmentData.ssm_heading,
      summary: departmentData.ssm_summery,
      services: departmentData.ssm_services,
      awards: departmentData.ssm_awards,
      status: departmentData.ssm_status
    };

    // Add consultation types if they exist
    if (departmentData.consultationTypes && departmentData.consultationTypes.length > 0) {
      apiData.consultationTypes = departmentData.consultationTypes.map(type => ({
        consultationType: type.consultationType,
        domesticCost: type.domesticCost,
        internationalCost: type.internationalCost,
        duration: type.duration,
        sharePercentage: type.sharePercentage || "0", // Default value
        gstPercentage: type.gstPercentage || "0" // Default value
      }));
    }

    // Add selected doctors if they exist
    if (departmentData.selectedDoctors && departmentData.selectedDoctors.length > 0) {
      apiData.selectedDoctors = departmentData.selectedDoctors;
    }

    const params = {
      requestType: 89,
      token: hashcode.toString(),
      data: apiData,
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managedepartment", params);

    if (response.status === 200) {
      dispatch({ 
        type: ADD_DEPARTMENT, 
        payload: response.data.data 
      });
      // Refresh the departments list
      dispatch(fetchDepartmentsList());
    }
    
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    return response.data.data;
  } catch (error) {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to add department" 
    });
    throw error;
  }
};

// Update Department
export const updateDepartment = (departmentData) => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    // Transform field names to match API expectations
    const apiData = {
      id: departmentData.ssm_id,
      name: departmentData.ssm_secondary_speciality_name,
      primarySpecialityId: departmentData.ssm_primary_speciality_id,
      details: departmentData.ssm_details,
      icon: departmentData.ssm_icon,
      heading: departmentData.ssm_heading,
      summary: departmentData.ssm_summery,
      services: departmentData.ssm_services,
      awards: departmentData.ssm_awards,
      status: departmentData.ssm_status
    };

    // Add consultation types if they exist
    if (departmentData.consultationTypes && departmentData.consultationTypes.length > 0) {
      apiData.consultationTypes = departmentData.consultationTypes.map(type => ({
        consultationType: type.consultationType,
        domesticCost: type.domesticCost,
        internationalCost: type.internationalCost,
        duration: type.duration,
        sharePercentage: type.sharePercentage || "0", // Default value
        gstPercentage: type.gstPercentage || "0" // Default value
      }));
    }

    // Add selected doctors if they exist
    if (departmentData.selectedDoctors && departmentData.selectedDoctors.length > 0) {
      apiData.selectedDoctors = departmentData.selectedDoctors;
    }

    const params = {
      requestType: 90,
      token: hashcode.toString(),
      data: apiData,
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managedepartment", params);

    if (response.status === 200) {
      dispatch({ 
        type: UPDATE_DEPARTMENT, 
        payload: response.data.data 
      });
      // Refresh the departments list
      dispatch(fetchDepartmentsList());
    }
    
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    return response.data.data;
  } catch (error) {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to update department" 
    });
    throw error;
  }
};

// Delete Department
export const deleteDepartment = (ssmId) => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    const params = {
      requestType: 91,
      token: hashcode.toString(),
      data: {
        departmentId: ssmId
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managedepartment", params);

    if (response.status === 200) {
      dispatch({ 
        type: DELETE_DEPARTMENT, 
        payload: ssmId 
      });
      // Refresh the departments list
      dispatch(fetchDepartmentsList());
    }
    
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    return response.data.data;
  } catch (error) {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to delete department" 
    });
    throw error;
  }
};

// Clear error
export const clearDepartmentError = () => (dispatch) => {
  dispatch({ type: CLEAR_DEPARTMENT_ERROR });
};

// Fetch Department Doctors List
export const fetchDepartmentDoctors = (departmentId) => async (dispatch) => {
  try {
    const params = {
      requestType: 93, // Assuming this is the request type for getdepartmentdoctorlist
      token: hashcode.toString(),
      data: {
        clinicName: "Ganga Hospital",
        ...(departmentId && { departmentId: departmentId })
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    console.log('Fetching doctors with params:', params);
    const response = await loginedApi.post("getdepartmentdoctorlist", params);
    console.log('Doctors API response:', response.data);

    if (response.status === 200) {
      return response.data.data;
    }
    
    return [];
  } catch (error) {
    console.error("Error fetching department doctors:", error);
    return [];
  }
};

// Speciality Management Actions
export const addSpeciality = (specialityData) => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    // Encode phone number: replace + with %2B
    const encodedPhone = specialityData.specialityPhone ? 
      specialityData.specialityPhone.replace(/\+/g, '%2B') : '';

    const params = {
      requestType: 98, // ADD_SPECIALITY_REQUEST
      token: hashcode.toString(),
      data: {
        specialityName: specialityData.specialityName,
        specialityImage: specialityData.specialityImage || '',
        specialityDescription: specialityData.specialityDescription || '',
        specialityStatus: specialityData.status || 'Active',
        specialityUrl: specialityData.specialityUrl || '',
        specialityNote: specialityData.specialityNote || '',
        specialityEmail: specialityData.specialityEmail || '',
        specialityPhone: encodedPhone
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managespeciality", params);

    if (response.status === 200) {
      dispatch(fetchSpecialities());
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to add speciality');
    }
  } catch (error) {
    console.error('Error adding speciality:', error);
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to add speciality" 
    });
    throw error;
  } finally {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
  }
};

export const updateSpeciality = (specialityData) => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    // Encode phone number: replace + with %2B
    const encodedPhone = specialityData.specialityPhone ? 
      specialityData.specialityPhone.replace(/\+/g, '%2B') : '';

    const params = {
      requestType: 99, // UPDATE_SPECIALITY_REQUEST
      token: hashcode.toString(),
      data: {
        specialityId: specialityData.specialityId,
        specialityName: specialityData.specialityName,
        specialityImage: specialityData.specialityImage || '',
        specialityDescription: specialityData.specialityDescription || '',
        specialityStatus: specialityData.status || 'Active',
        specialityUrl: specialityData.specialityUrl || '',
        specialityNote: specialityData.specialityNote || '',
        specialityEmail: specialityData.specialityEmail || '',
        specialityPhone: encodedPhone
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managespeciality", params);

    if (response.status === 200) {
      dispatch(fetchSpecialities());
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to update speciality');
    }
  } catch (error) {
    console.error('Error updating speciality:', error);
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to update speciality" 
    });
    throw error;
  } finally {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
  }
};

export const deleteSpeciality = (specialityId) => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    const params = {
      requestType: 100, // DELETE_SPECIALITY_REQUEST
      token: hashcode.toString(),
      data: {
        specialityId: specialityId
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managespeciality", params);

    if (response.status === 200) {
      dispatch(fetchSpecialities());
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to delete speciality');
    }
  } catch (error) {
    console.error('Error deleting speciality:', error);
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to delete speciality" 
    });
    throw error;
  } finally {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
  }
};

// Get Speciality by ID
export const fetchSpecialityById = (specialityId) => async (dispatch) => {
  try {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: true });
    dispatch({ type: CLEAR_DEPARTMENT_ERROR });

    const params = {
      requestType: 97, // GET_SPECIALITY_BY_ID_REQUEST
      token: hashcode.toString(),
      data: {
        specialityId: specialityId
      },
      userAgent: userAgent,
      ipaddress: "192.168.1.1"
    };

    const response = await loginedApi.post("managespeciality", params);

    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to fetch speciality');
    }
  } catch (error) {
    console.error('Error fetching speciality by ID:', error);
    dispatch({ 
      type: SET_DEPARTMENT_ERROR, 
      payload: error.response?.data?.message || "Failed to fetch speciality" 
    });
    throw error;
  } finally {
    dispatch({ type: SET_DEPARTMENT_LOADING, payload: false });
  }
};
